import FormularioCategoria from "./FormularioCategoria";

const AgregarCategoria = () => {
  return (
    <div>
      <div className="container mt-4">
        <h1 className="text-center mb-4">Agregar Nueva Categoria</h1>
        <FormularioCategoria id={null} categoria={null} />
      </div>
    </div>
  );
};

export default AgregarCategoria;
